// extracted by mini-css-extract-plugin
export var progressBar = "_jc-0";
export var progressBarInner = "_jc-1";